export const TimeConverter = {
    millisecondsToMinutes(millis) {
        return Math.round(millis / 60000);
    }
};
